var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcondoorOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7832 16.9105C23.9316 16.9105 24.0801 16.9847 24.1914 17.0961C24.3027 17.2074 24.377 17.3558 24.377 17.5043V18.6918C24.377 18.8773 24.3027 19.0258 24.1914 19.1371C24.0801 19.2484 23.9316 19.2855 23.7832 19.2855H18.4395V5.03552H14.877V2.66052H19.0332C19.5156 2.66052 19.9238 2.84607 20.2949 3.21716C20.6289 3.58826 20.8145 3.99646 20.8145 4.47888V16.9105H23.7832ZM12.2051 0.322632C12.5762 0.248413 12.9102 0.322632 13.207 0.545288C13.5039 0.805054 13.6895 1.13904 13.6895 1.51013V19.2855H1.2207C1.03516 19.2855 0.886719 19.2484 0.775391 19.1371C0.664062 19.0258 0.626953 18.8773 0.626953 18.6918V17.5043C0.626953 17.3558 0.664062 17.2074 0.775391 17.0961C0.886719 16.9847 1.03516 16.9105 1.2207 16.9105H4.18945V3.3656C4.18945 3.10583 4.26367 2.84607 4.44922 2.62341C4.59766 2.40076 4.82031 2.25232 5.08008 2.1781L12.2051 0.322632ZM10.4238 10.973C10.6465 10.973 10.8691 10.8617 11.0547 10.639C11.2031 10.4164 11.3145 10.1195 11.3145 9.78552C11.3145 9.48865 11.2031 9.19177 11.0547 8.96912C10.8691 8.74646 10.6465 8.59802 10.4238 8.59802C10.1641 8.59802 9.94141 8.74646 9.79297 8.96912C9.60742 9.19177 9.5332 9.48865 9.5332 9.78552C9.5332 10.1195 9.60742 10.4164 9.79297 10.639C9.94141 10.8617 10.1641 10.973 10.4238 10.973Z",
    fill: "#413E3F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcondoorOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.door-open.f467287de958f0b00092c88c5df6b970.svg";